// extracted by mini-css-extract-plugin
export var content = "style-module--content--12e64";
export var contentInner = "style-module--content-inner--dd893";
export var icon = "style-module--icon--9f0c1";